import styled, { css } from 'styled-components'

import { applyIPadOnlyStyle } from 'helpers/css'
import { isDesktop } from 'utils/device'

export const SketchPickerContainer = styled.div`
    position: absolute;
    left: 5vw;
    top: 2vw;
    z-index: 34;
    bottom: 110px;
`

export const Sketch = styled.div`
    width: inherit;
    height: inherit;
    background: linear-gradient(0deg, #ffffff, #ffffff);
    box-sizing: border-box;
    box-shadow: 0px 14.2794px 28.5588px rgba(0, 0, 0, 0.06);
    border-radius: 12px;
    ${applyIPadOnlyStyle('height:55vh')}
`

export const CanvasStyle = styled.canvas`
    width: inherit !important;
    height: inherit !important;
    ${props =>
        props.isTeacher
            ? css`
                  cursor: crosshair;
                  touch-action: none;
              `
            : null}
    @media only screen and (orientation: portrait) {
        ${!isDesktop &&
            css`
                height: 100% !important;
            `}}
    }
`
